<template functional>
  <div
    class="dataset-cell-text-truncate"
    v-bind="data.attrs"
    :class="[data.staticClass, props.class]"
    :title="props.value"
  >
    {{ $options.truncate(props.value, props.column.format_data.limit || 100) }}
  </div>
</template>

<script>
import { truncate } from '@/lib/text-helper'
import ModuleBase from './module-base'

export default {
  name: 'DatasetCellText',
  mixins: [ModuleBase],
  truncate,
}
</script>

<style lang="scss">
@import '@/style/inject';

.dataset-cell-text-truncate {
  color: $beige;
}
</style>
